export default class Header {
    constructor() {
        this.header = $('.header')
        this.triggers = $('.header a[data-dropdown]')
        this.subTriggers = $('.menu__categories a[data-grid]')
        this.categoryTriggers = $('.header a[data-submenu]')
        this.darkLayer = $('.modal__layer')
        this.dropdownContent = $('.menu__grid')
        this.dropdownClose = $('.dropdown__close')
        this.dropdownShowcase = $('.menu__showcase')
        this.dropdownShowcaseItems = $('.menu__showcase__item')
        this.dropdownProductLinks = $('.menu__products a[data-preview]')
        this.dropdownPreview = $('.menu__category__preview')
        this.dropdownPreviewTarget = $('.menu_category_preview_target')
        this.nav = $('.navigation')
        this.navToggler = $('.header__toggler')
        this.search = $('.header__search')
        this.searchTrigger = $('.header__search__toggler')
        this.searchClose = $('.header__search__close')
        this.searchInput = $('#dropdown-search .wrapper input')
        this.searchDropdown = $('#dropdown-autocomplete')
        this.authForgotTrigger = $('.dropdown__auth__forgot > a[data-trigger-auth-forgot]')
        this.authLoginTrigger = $('.dropdown__auth__forgot > a[data-trigger-auth-login]')
        this.customizedSelect = $('.select--customized select')
        this.isMobile = false
    }

    /**
     * Hide dropdowns and layers
     */
    hideAll() {
        this.closeAll()

        this.header.removeClass('is-dropdown-open')
        this.darkLayer.removeClass('is-open').hide()
        this.nav.removeClass('is-open')
        this.search.removeClass('is-focused')
        this.resetProductPreview()
    }

    /**
     * Close everything but leave the layer
     */
    closeAll() {
        $('.modal, .modal__layer, .dropdown, .header a[data-dropdown], .navigation').removeClass('is-open')
        $('.modal, .modal__layer').hide()
        $('.header__toggler').removeClass('is-active')
        this.search.removeClass('is-focused')
        $('body').removeClass('no-scroll')
    }

    /**
     * Hide dropdown grids
     */
    hideContent() {
        $('.menu__categories a').removeClass('is-active')
        this.dropdownContent.removeClass('is-open')
        this.resetProductPreview()
    }

    /**
     * Hide mobile dropdown grids
     */
    hideContentMobile() {
        $('.menu__categories ul li a').removeClass('is-active')
        $('.menu__grid__mobile').removeClass('is-open')
    }

    /**
     * Open dropdown
     */
    openDropdown(me, target) {
        if (target.attr('id') === 'dropdown-basket' && $('body').hasClass('l-basket-index')) {
            return false
        }

        if (this.isMobile && me.hasClass('mobile-menu-dropdown')) {
            this.hideContentMobile()

            if (!me.hasClass('is-open')) {
                $('.dropdown, .header a[data-dropdown]').removeClass('is-open')
                me.addClass('is-open')
                target.addClass('is-open')
                this.header.addClass('is-open')
            } else {
                $('.dropdown, .header a[data-dropdown]').removeClass('is-open')
            }
            return false
        }

        if (!me.hasClass('is-open')) {
            this.closeAll()

            me.addClass('is-open')
            target.addClass('is-open')
            this.darkLayer.addClass('is-open').fadeIn(250)
            this.header.addClass('is-open')

            if (target.attr('id') === 'dropdown-search') {
                this.searchInput.focus()
            }
        } else {
            this.closeAll()
        }
    }

    /**
     * Handle clicking on dropdown trigger
     */
    handleClick(e) {
        e.preventDefault()
        let me = $(e.currentTarget)

        if (!this.isMobile) {
            let target = $(`#dropdown-${me.data('dropdown')}`)

            this.openDropdown(me, target)
        } else {
            let target = me.parent().find('.navigation__category')

            if (target.length) {
                me.toggleClass('is-active')
                target.toggleClass('is-open')
            } else {
                this.openDropdown(me, $(`#dropdown-${me.data('dropdown')}`))
            }
        }
    }

    /**
     * Handle clicking on sidebar links
     */
    handleSidebarClick(e) {
        e.preventDefault()
        let me = $(e.currentTarget)
        let target
        if (this.isMobile) {
            target = $(`#mobile-grid-${me.data('grid')}`)
        } else {
            target = $(`#grid-${me.data('grid')}`)
        }
        if (target) {
            if (this.isMobile) {
                if (me.hasClass('is-active')) {
                    this.hideContentMobile()
                } else {
                    this.hideContentMobile()
                    me.addClass('is-active')
                    target.addClass('is-open')
                }
            } else {
                this.hideContent()
                me.addClass('is-active')
                target.addClass('is-open')
            }
        }
    }

    /**
     * Handle clicking on category links
     */
    handleCategoryClick(e) {
        if (this.isMobile) {
            e.preventDefault()
            let me = $(e.currentTarget)
            let target = $(`#submenu-${me.data('submenu')}`)

            if (target) {
                me.toggleClass('is-active')
                target.toggleClass('is-open')
            }
        }
    }

    /**
     * Toggle navigation links on mobile
     */
    toggleNav() {
        if (!this.nav.hasClass('is-open')) {
            this.closeAll()

            $('body').addClass('no-scroll')
            this.darkLayer.addClass('is-open').fadeIn(250)
            this.nav.addClass('is-open')
            this.navToggler.addClass('is-active')
            $('a.mobile-menu-dropdown').first().addClass('is-open')
            $('a.mobile-menu-dropdown').next('.dropdown').first().addClass('is-open')
            this.hideContentMobile()
        } else {
            this.closeAll()
        }
    }

    /**
     * Check for mobile devices
     */
    checkMobile() {
        let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        let state = this.isMobile

        this.isMobile = w <= 1024 ? true : false
    }

    /**
     * Toggle visibiltiy of search on mobile
     */
    toggleSearch(e) {
        e.preventDefault()
        let me = $(e.currentTarget)

        me.toggleClass('is-open')
        this.search.toggleClass('is-open')

        if (!this.search.hasClass('is-open')) {
            this.hideAll()
        }
    }

    resetSearch(e) {
        e.preventDefault()
        this.searchInput.val('')
    }

    /**
     * Handle focus on search
     */
    handleFocusSearch() {
        if (this.search.hasClass('is-focused')) {
            this.search.removeClass('is-focused')
            this.searchDropdown.removeClass('is-open')
            this.hideAll()
        } else {
            this.darkLayer.addClass('is-open').fadeIn(250)
            this.search.addClass('is-focused')
            this.searchDropdown.addClass('is-open')
        }
    }

    /**
     * Show forgot password form instead of login
     */
    toggleForgot() {
        $('.dropdown-toggleform-login input').attr('disabled', 'disabled')
        $('.dropdown-toggleform-login').hide()

        $('.dropdown-toggleform-forgot').fadeIn(250)
        $('.dropdown-toggleform-forgot input').attr('disabled', false)
    }

    /**
     * Show login form instead of forgot password
     */
    toggleLogin() {
        $('.dropdown-toggleform-forgot input').attr('disabled', 'disabled')
        $('.dropdown-toggleform-forgot').hide()

        $('.dropdown-toggleform-login').fadeIn(250)
        $('.dropdown-toggleform-login input').attr('disabled', false)
    }

    /**
     * Toggle showcase item opacities
     */
    toggleShowcaseHover(e) {
        if (!this.isMobile) {
            this.dropdownShowcase.addClass('uses-focus')
        }
        $(e.currentTarget).addClass('is-focused')
    }

    resetShowcase() {
        this.dropdownShowcase.removeClass('uses-focus')
        this.dropdownShowcaseItems.removeClass('is-focused')
    }

    switchProductPreview(e) {
        let previewUrl = $(e.currentTarget).data('preview')
        let previewLink = $(e.currentTarget).data('targeturl')
        let gridId = $(e.currentTarget).closest('.menu__grid').attr('id')

        $('.menu__category__preview[data-menu-id="' + gridId + '"]').attr('src', previewUrl).parent().attr('href',previewLink)
    }

    resetProductPreview() {
        this.dropdownPreview.each(function() {
            $(this).attr('src', $(this).data('original-src'))
            $(this).parent().attr('href', $(this).parent().data('original-href'))
        })
    }

    /**
     * Customized select
     */
    customizeSelectElements(){
        this.customizedSelect.each(function () {

            var $this = $(this),
                numberOfOptions = $(this).children('option').length

            $this.addClass('hidden-select')

            $this.after('<div class="styled-select"></div>')

            var $styledSelect = $this.next('div.styled-select')

            $styledSelect.text($this.children('option').eq(0).text())

            var $list = $('<ul />', {
                'class': 'styled-options'
            }).insertAfter($styledSelect)

            for (var i = 0; i < numberOfOptions; i++) {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list)
            }

            var $listItems = $list.children('li')

            $styledSelect.on('click', function (e) {
                e.stopPropagation()
                $('div.styled-select.active').each(function () {
                    $(this).removeClass('active').next('ul.styled-options').hide()
                })
                $(this).toggleClass('active').next('ul.styled-options').toggle()
            })

            $listItems.on('click', function (e) {
                e.stopPropagation()
                $styledSelect.text($(this).text()).removeClass('active')
                $this.val($(this).attr('rel'))
                $list.hide()
            })

            $(document).on('click', function () {
                $styledSelect.removeClass('active')
                $list.hide()
            })

        })
    }

    isGdprModalVisible() {
        return $('#modal-gdpr').hasClass('is-open') || $('#modal-gdpr-info').hasClass('is-open')
    }

    /**
     * Register event listeners
     */
    registerEvents() {
        // Search visibility on mobile
        this.searchTrigger.on('click', e => this.toggleSearch(e))
        this.searchClose.on('click', e => this.resetSearch(e))

        // Close everything on 'x' links
        $(document).on('click', '.dropdown__close', () => this.hideAll())

        // Search input focus
        // this.searchInput.on('focus', () => this.handleFocusSearch())
        // this.searchInput.on('blur', () => this.handleFocusSearch())

        // Top level clicks
        this.triggers.on('click', e => this.handleClick(e))

        // Submenu level clicks
        this.subTriggers.on('click', e => this.handleSidebarClick(e))

        // Category level clicks
        this.categoryTriggers.on('click', e => this.handleCategoryClick(e))

        // Mobile menu clicks
        this.navToggler.on('click', () => this.toggleNav())

        // Closing for clicking on dark layer
        this.darkLayer.on('click', () => this.hideAll())

        // Handling forgot/login behaviour
        this.authForgotTrigger.on('click', () => this.toggleForgot())
        this.authLoginTrigger.on('click', () => this.toggleLogin())

        // Showcase block hovers
        this.dropdownShowcaseItems.hover(e => {
            this.toggleShowcaseHover(e)
        }, () => {
            this.resetShowcase()
        })

        // Dropdown preview hovers
        this.dropdownProductLinks.hover(e => {
            this.switchProductPreview(e)
        })

        // Closing for Esc key
        $(document).on('keyup', e => {
            if (e.keyCode === 27 && !this.isGdprModalVisible()) {
                this.hideAll()
            }
        })

        // Check viewport
        $(window).on('resize', () => this.checkMobile())
    }

    /**
     * Initialize class
     */
    init() {
        if (this.header && this.triggers) {
            this.registerEvents()
        }

        this.checkMobile()
        this.customizeSelectElements()
    }
}
